import RouteMetadata from './seo/RouteMetadata';
import { submitMailchimpSignup } from './Landing/waitlist/mailchimp';
import "./App.css";
import PageLoader from "./components/PageLoader";


// import { Home } from "./Landing/Home";
import { Landing } from "./Landing/Landing";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import  ProtectedRoute  from "./components/ProtectedRoute";

const NotFound = lazy(() => import("./Landing/NotFound"));
const Waitlist = lazy(() => import("./Landing/waitlist/Waitlist"));
const About = lazy(() => import("./Landing/About").then(module => ({ default: module.About })));
const Pricing = lazy(() => import("./Landing/Pricing").then(module => ({ default: module.Pricing })));
const Help = lazy(() => import("./Landing/Help").then(module => ({ default: module.Help })));
const Privacy = lazy(() => import("./Landing/Privacy").then(module => ({ default: module.Privacy })));
const DeleteAccount = lazy(() => import("./Landing/DeleteAccount").then(module => ({ default: module.DeleteAccount })));
const Launch = lazy(() => import("./Landing/Launch").then(module => ({ default: module.Launch })));
const RegisterLaunch = lazy(() => import("./Landing/RegisterLaunch").then(module => ({ default: module.RegisterLaunch })));
const Layout = lazy(() => import("./Admin/Layout").then(module => ({ default: module.Layout })));
const Dashboard = lazy(() => import("./Admin/Dashboard").then(module => ({ default: module.Dashboard })));
const Signup = lazy(() => import("./Onboarding/Signup").then(module => ({ default: module.Signup })));
const Confirmemail = lazy(() => import("./Onboarding/Confirmemail").then(module => ({ default: module.Confirmemail })));
const Login = lazy(() => import("./Onboarding/Login").then(module => ({ default: module.Login })));
const Reset = lazy(() => import("./Onboarding/Reset").then(module => ({ default: module.Reset })));
const Getapp = lazy(() => import("./Onboarding/Getapp").then(module => ({ default: module.Getapp })));
const Writers = lazy(() => import("./Admin/Writers").then(module => ({ default: module.Writers })));
const Users = lazy(() => import("./Admin/Users").then(module => ({ default: module.Users })));
const Consultants = lazy(() => import("./Admin/Consultants").then(module => ({ default: module.Consultants })));
const WriterDetails = lazy(() => import("./Admin/WriterDetails").then(module => ({ default: module.WriterDetails })));
const UserDetails = lazy(() => import("./Admin/UserDetails").then(module => ({ default: module.UserDetails })));
const AddWriter = lazy(() => import("./Admin/AddWriter").then(module => ({ default: module.AddWriter })));
const AddConsultant = lazy(() => import("./Admin/AddConsultant").then(module => ({ default: module.AddConsultant })));
const MediaPress = lazy(() => import("./Landing/press/Press").then(module => ({ default: module.MediaPress })));
const PressArchive = lazy(() => import("./Landing/press/Press").then(module => ({ default: module.PressArchive })));

const LazyPressArticle = lazy(() => import("./Landing/press/LazyPressArticle"));

function App() {
  const subdomain = typeof window === "undefined" ? "yourhaven" : window.location.hostname.split(".")[0];
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const branded = subdomain !== 'admin' && (location.pathname === '/' || location.pathname === '/404' || location.pathname === '/register-launch' || location.pathname.startsWith('/waitlist') || location.pathname.startsWith('/media-and-press'));
    if (branded || document.getElementById('haven-legacy-fonts')) return;
    const link = document.createElement('link');
    link.id = 'haven-legacy-fonts';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Wix+Madefor+Display:wght@400..800&display=swap';
    document.head.appendChild(link);
  }, [location.pathname, subdomain]);

  // Redirect mobile and tablet users on admin subdomain
  useEffect(() => {
    if (subdomain === "admin") {
      const isMobileOrTablet = window.innerWidth < 1172;
      const currentPath = location.pathname;
      if (isMobileOrTablet && currentPath !== "/download") {
        navigate("/download"); // Redirect to the download page
      }
    }
  }, [navigate, subdomain, location.pathname]);

  return (
    <div className="App font-wix">
      <RouteMetadata />
      <Suspense fallback={<PageLoader />}>
      {subdomain === "admin" ? (
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="writers" element={<Writers />} />
            <Route path="users" element={<Users />} />
            <Route path="consultants" element={<Consultants />} />
            <Route path="writers/:userid" element={<WriterDetails />} />
            <Route path="users/:userid" element={<UserDetails />} />
            <Route path="addwriter" element={<AddWriter />} />
            <Route path="addconsultant" element={<AddConsultant />} />
          </Route>
          <Route path="download" element={<Getapp />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      ) : (

          <Routes>
            <Route path="/" element={<Landing />}>
              <Route index element={<Launch />} />
              <Route path="about" element={<About />} />
              <Route path="pricing" element={<Pricing />} />
              <Route path="help" element={<Help />} />
              <Route path="privacy" element={<Privacy />} />
              <Route path="delete-account" element={<DeleteAccount />} />
              <Route path="register-launch" element={<RegisterLaunch />} />
              <Route path="waitlist" element={<Waitlist submitSignup={submitMailchimpSignup} />} />
              <Route path="media-and-press" element={<MediaPress />} />
              <Route path="media-and-press/releases" element={<PressArchive />} />
              <Route path="media-and-press/:slug" element={<LazyPressArticle />} />
              <Route path="404" element={<NotFound />} />
            </Route>

            {/* Other Routes */}
            <Route path="signup" element={<Signup />} />
            <Route path="confirm" element={<Confirmemail />} />
            <Route path="login" element={<Login />} />
            <Route path="reset" element={<Reset />} />
            <Route path="download2" element={<Getapp />} />

            <Route
              path="download"
              element={
                <ProtectedRoute>
                  <Getapp />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>

      )}
      </Suspense>
    </div>
  );
}

export default App;
